<template>
  <b-container fluid class="animated fadeIn"><br />
    <h1>Inicial</h1>
    <div align="center"> 
    <img src="../../../public/proaju.png" alt="Home" class="img-fluid" />
    </div>
  </b-container>
</template>

<script>
export default {
  name: "home"
};
</script>
